import styled from 'styled-components'

export const INK = '#0C1229'
export const MUTED = '#4d4d56'
export const BORDER = '#e4e4e7'
export const ACCENT = '#33becc'
export const ACCENT_HOVER = '#2aa6b3'
export const ACCENT_SOFT = '#e6f7f9'
export const LINK = '#17727b'

export const PrimaryButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 40px;
  padding: 0 16px;
  border: 1px solid ${ACCENT};
  border-radius: 8px;
  background: ${ACCENT};
  color: #fff;
  font: inherit;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: background-color 0.15s ease;
  &:hover:not(:disabled) { background: ${ACCENT_HOVER}; border-color: ${ACCENT_HOVER}; }
  &:focus-visible { outline: 2px solid ${INK}; outline-offset: 2px; }
  &:disabled { opacity: 0.5; cursor: not-allowed; }
`

export const SecondaryButton = styled(PrimaryButton)`
  background: #fff;
  color: ${INK};
  border-color: #d4d4d8;
  &:hover:not(:disabled) { background: #f4f4f5; border-color: #a1a1aa; }
`

export const TextButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  min-height: 40px;
  padding: 0 6px;
  border: none;
  background: none;
  color: ${LINK};
  font: inherit;
  font-size: 15px;
  font-weight: 600;
  text-decoration: underline;
  text-underline-offset: 3px;
  cursor: pointer;
  &:focus-visible { outline: 2px solid ${INK}; outline-offset: 2px; }
  &:disabled { opacity: 0.5; cursor: not-allowed; }
`
